(function () {
  // ---------- simple math captcha ----------
  // Generated client-side (not in Liquid) so the numbers never sit in the
  // page's cached static HTML for a bot to read or pre-solve. Blocks the
  // common class of spam bot that just scrapes field names from the form
  // and POSTs directly, without ever executing JS.
  var qEl = document.querySelector('[data-captcha-question]');
  var input = document.getElementById('captchaAnswer');
  var errorEl = document.querySelector('[data-captcha-error]');
  var expected = null;

  function newCaptchaChallenge() {
    var a = Math.floor(Math.random() * 8) + 2; // 2-9
    var b = Math.floor(Math.random() * 8) + 2; // 2-9
    expected = a + b;
    if (qEl) qEl.textContent = a + ' + ' + b + ' =';
    if (input) {
      input.value = '';
      input.setAttribute('aria-label', 'Security check: what is ' + a + ' plus ' + b + '?');
    }
  }

  if (qEl && input) {
    newCaptchaChallenge();

    window.bannerFormCaptchaIsValid = function () {
      var val = parseInt(input.value, 10);
      var ok = !isNaN(val) && val === expected;
      if (errorEl) errorEl.classList.toggle('is-visible', !ok);
      if (!ok) {
        input.focus();
        newCaptchaChallenge();
      }
      return ok;
    };
  } else {
    // captcha markup missing for some reason -- fail safe, don't block real submissions
    window.bannerFormCaptchaIsValid = function () { return true; };
  }
})();

document.getElementById('bannerForm').addEventListener('submit', function(event) {
    event.preventDefault();

    if (typeof window.bannerFormCaptchaIsValid === 'function' && !window.bannerFormCaptchaIsValid()) {
      return;
    }
  
    // Get the current date and time
    var currentDate = new Date();
    var date = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    var time = currentDate.toTimeString().split(' ')[0]; // Format: HH:MM:SS
  
    // Set the values in the hidden fields
    document.getElementById('formDate').value = date;
    document.getElementById('formTime').value = time;
  
    var form = document.getElementById('bannerForm');
    var formData = new FormData(form);
    var submitButton = document.getElementById('submitButton');
    var loader = document.getElementById('loader');
  
    // Show loader and disable submit button
    loader.style.display = 'inline-block';
    submitButton.disabled = true;
  
    fetch(form.action, {
      method: 'POST',
      mode: 'no-cors',
      body: formData,
    })
    .then(response => response.text())
    .then(result => {
      // Hide loader, enable button, and display thank-you message
      loader.style.display = 'none';
      submitButton.disabled = false;
      document.getElementById('bannerForm').style.display = 'none';
      document.getElementById('thankYouMessage').style.display = 'flex';
      
      var currentUrl = window.location.href;
      var newUrl = currentUrl + (currentUrl.includes('?') ? '&' : '?') + 'request_submitted=true';
      window.history.replaceState(null, null, newUrl);
    })
    .catch(error => {
      console.error('Error:', error);
      loader.style.display = 'none';
      submitButton.disabled = false;
    });
  });
  